import { paginate } from '@utils'
import { useState } from 'react'

export default function usePagination() {
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)
    const handlePageChange = (_: unknown, newPage: number) => setPage(newPage)
    const handleRowsPerPageChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    return {
        handlePageChange,
        handleRowsPerPageChange,
        page,
        paginate,
        rowsPerPage,
    }
}
